import Utils from '@/ecm/common/Utils'
export default class GroupItem {
    constructor() {
        this.uuid = Utils.object.getUUID()
        this.fieldTitle = ''
        this.sumFields = []
        this.maxFields = []
        this.minFields = []
        this.avgFields = []
        this.summarizeOnlySelectedDocuments = false
    }
}
